/* Menu.ts */

export enum MenuType {
  DEFAULT = "default",
  MAIN = "main",
  INSIGHTS_FILTER = "insights-filter",
  ADMIN_DASHBOARD = "admin-dashboard",
}

export enum MenuContentType {
  INSIGHTS_FILTER = "insights-menu-content",
  ADMIN_DASHBOARD = "admin-dashboard-menu-content",
}
